export const getRefreshTokenFromLocalStorage = () => {
  const token = JSON.parse(localStorage.getItem('auth') ?? '{}');

  return token?.refreshToken ?? null;
};
